import { AnyAction, Reducer } from "redux";

export interface IT2SState {
  t2sLoaded: boolean;
}

export const initialState: IT2SState = {
  t2sLoaded: false,
};

const t2sReducer: Reducer<IT2SState> = (
  state: IT2SState = initialState,
  action: AnyAction
): IT2SState => {
  if (action.type === "T2S_LOADED") {
    return { ...action.payload };
  }

  return state;
};

export default t2sReducer;
